export const ON_WIDGET_OPEN_EVENT = 'open'
export const ON_WIDGET_CLOSE_EVENT = 'close'
export const ON_USER_SENT_MSG = 'raychat_sendMessage'
export const ON_MSG_RECEIVED_FROM_OPERATOR = 'raychat_getMessage'
export const ON_NEW_USER_LOADED = 'raychat_new_user_loaded'
export const ON_FORM_SUBMISSION = 'raychat_form_submission'
export const ON_USER_DETAILS_UPDATED = 'raychat_user_profile_updated'
